import { Fragment } from 'react';

import Checkbox from '@usas/ui-web/components/checkboxes/Checkbox';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const AthleteUserCredentialsSelectionSmallGrid = ({ gridData, isLoading, onCheckboxChange }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>
            &nbsp;
          </div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>
              Loading...
            </div>
          </div>
        </div>
      ) : gridData?.length > 0
        ? gridData?.map((credential, i) => (
          <div className={global.SmallTableRow} key={credential.orgUnitNonAthleteEntryId || i}>
            <div className={global.SmallTableRowHead}>
              {credential.credentialEntered === false ?
                <Fragment><span className='hidden-xs'>{(credential.firstName || credential.middleName || credential.lastName) ? `${credential.firstName || ''}  ${credential.preferredName !== '' && credential.preferredName !== credential.firstName ? '"' + credential.preferredName + '"' : ''} ${credential.middleName || ''} ${credential.lastName || ''}` : <span>&nbsp;</span>}</span>&nbsp;</Fragment>
                :
                <Fragment>{credential.credentialEnteredOmeMeetName ? `Entered under ${credential.credentialEnteredOmeMeetName}` : <span>&nbsp;</span>}</Fragment>}
              <div className={global.CheckboxMobile}>
                {credential.credentialEntered === false ?
                  <Fragment>
                    {credential.hasPaid === false ?
                      <Checkbox
                        className={global.IconButton}
                        label=""
                        name="isSelected"
                        onChange={(e) => { onCheckboxChange(e, credential.personId) }}
                        checked={credential.isSelected} /> :
                      <Checkbox
                        className={global.IconButton}
                        label=""
                        name="isSelected"
                        onChange={(e) => { onCheckboxChange(e, credential.personId) }}
                        checked={credential.isSelected}
                        disabled={true} />}
                  </Fragment>
                  :
                  <Fragment>
                    <Checkbox
                      className={global.IconButton}
                      label=""
                      name="isSelected"
                      onChange={(e) => { onCheckboxChange(e, credential.personId) }}
                      checked={true}
                      disabled={true} />
                  </Fragment>
                }
              </div>
            </div>
            <div className={global.SmallTableRowInfo}>
              <div className='row'>
                {credential.credentialEntered === false ?
                  <Fragment>
                    <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>Name</div>
                    <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>{(credential.firstName || credential.middleName || credential.lastName) ? `${credential.firstName || ''}  ${credential.preferredName !== '' && credential.preferredName !== credential.firstName ? '"' + credential.preferredName + '"' : ''} ${credential.middleName || ''} ${credential.lastName || ''}` : <span>&nbsp;</span>}</div>
                  </Fragment> :
                  <Fragment>
                    <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Name</div>
                    <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{(credential.firstName || credential.middleName || credential.lastName) ? `${credential.firstName || ''}  ${credential.preferredName !== '' && credential.preferredName !== credential.firstName ? '"' + credential.preferredName + '"' : ''} ${credential.middleName || ''} ${credential.lastName || ''}` : <span>&nbsp;</span>}</div>
                  </Fragment>}
                <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Member Id</div>
                <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{credential.memberId || <span>&nbsp;</span>}</div>
                <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Email</div>
                <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{credential.email || <span>&nbsp;</span>}</div>
                <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>In Good Standing?</div>
                <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{credential.isInGoodStanding === true ? 'Yes' : credential.isInGoodStanding === false ? 'No' : <span>&nbsp;</span>}</div>
                <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Expiration Date</div>
                <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{credential.isInGoodStandingExpirationDate ? formatDate(credential.isInGoodStandingExpirationDate) : <span>&nbsp;</span>}</div>
              </div>
            </div>
          </div>
        )) : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>
              &nbsp;
            </div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Results</div>
            </div>
          </div>
        )
    }
  </div >
);

export default AthleteUserCredentialsSelectionSmallGrid;